<template>
  <a-descriptions :column='1'>
    <a-descriptions-item label="物流公司">{{extractData.express_company}}</a-descriptions-item>
    <a-descriptions-item label="快递单号">{{extractData.express_no}}</a-descriptions-item>
  </a-descriptions>
  <a-timeline v-if='logisticsList.length' class="m-t-30">
    <a-timeline-item v-for="(item,index) in logisticsList" :key='index'>
      <p>{{item.context}}</p>
      <p class="s_c999 fz-12 m-t-5">{{item.time}}</p>
    </a-timeline-item>
  </a-timeline>
  <a-empty description='暂无物流信息' v-else/>
</template>
<script>
import { ref,onMounted } from "vue";
export default {
  name: "logisticsDetails",
  props: {
    data:Object
  },
  setup(props) {
    const logisticsList = ref([]);
    const extractData = ref({});
    onMounted(() => {
      logisticsList.value = props.data.list
      extractData.value = props.data.order_extract
    });
    return {
      logisticsList,
      extractData
    };
  },
};
</script>